import ChooseModel from '@/custom-component/bindModel/ButtonType.vue'
export default {
  components: {
    ChooseModel
  },
	computed:{
		columnClass() {
			const arr = ['first-column','second-column','three-column'];
			const span = this.element.config.__ques__.optSpan
			let number = 0 // 选项展示一栏
			if(span === 12) number = 1 // 选项展示二栏
			if(span === 8) number = 2  // 选项展示三栏
			return arr[number]
		},
	},
	data () {
		return {
			optNumber: ['A','B','C','D','E','F','G','H','J','O','P','Q','R'],
			optRoman: ['Ⅰ','Ⅱ','Ⅲ','Ⅳ','Ⅴ','Ⅵ','Ⅶ','Ⅷ','Ⅸ','Ⅹ']
		}
	},
	methods: {
    openModelDrawer() {
      this.$nextTick(() => {
        this.$refs.chooseModel.show = true
      })
    }
  }
}
